// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Tag } from '@teamnine/pcj-ui-v2'

import { Template as ITemplate } from '@/services/templates'

type TemplateStatusTagProps = {
  template?: ITemplate
}

export default function TemplateStatusTag({
  template,
}: TemplateStatusTagProps) {
  const color = template?.golden
    ? 'warning'
    : template?.published
      ? 'info'
      : 'secondary'
  const label = template?.golden
    ? 'Golden'
    : template?.published
      ? 'Published'
      : 'Draft'

  return <Tag color={color}>{label}</Tag>
}
